
function password_generator(len) {
    if (len === "" || len === 0){
        len = 8;
    }
    var length = len;
    var string = "abcdefghijklmnopqrstuvwxyz"; //to upper
    var numeric = '0123456789';
    var symbol = '!,;.:-_+*~#()[]<>|=?';
    var password = "";
    var character = "";
    while (password.length < length) {
        var alphabetCharacter = Math.ceil(string.length * Math.random() * Math.random());
        var number = Math.ceil(numeric.length * Math.random() * Math.random());
        var specialCharacter = Math.ceil(symbol.length * Math.random() * Math.random());
        var letter = string.charAt(alphabetCharacter);
        letter = (password.length % 2 === 0) ? (letter.toUpperCase()) : (letter);
        character += letter;
        character += numeric.charAt(number);
        character += symbol.charAt(specialCharacter);
        password = character;
    }
    password = password.split('').sort(function () {
        return 0.5 - Math.random()
    }).join('');
    var result = password.substr(0, len);
    if (checkRules(result)) {
        return result;
    } else {
        console.log('rerun');
        return password_generator(len);
    }
}

export default password_generator;
